import {Injectable} from "@angular/core";
import {OptionService} from "../option/option.service";

/**
 * Service with helper functions for embedded advisors
 */
@Injectable({
  providedIn: 'root'
})
export class EmbedService {
  /**
   * tells the embedding page to scroll to the top
   */
  scrollToTop(offset: number = 0): void {
    if (this.isEmbedded()) {

      // only scroll to the element if it is really visible.
      // if(offset + this.currentOffset < 0 || Math.abs(offset + this.currentOffset) > this.availableHeight) {
        window.parent.postMessage({
          "type": "scrollToTop",
          "value": offset,
          "cid": OptionService.getConatinerId()
        }, "*");
      // }
    }
  }

  /**
   * retruns if the advisor is embedded or not.
   */
  isEmbedded(): boolean {
    return window.parent && window !== window.parent;
  }
}
